export default class Folgeimpfstoff {
    /** PK: Folgeimpfstoff Identifikation | erforderlich **/
    public folgeimpfstoff_id: number | null = null;
    /** Impfstoff **/
    public impfstoff_id: number | null = null;
    /** Folgeimpfstoff **/
    public folge_impfstoff_id: number | null = null;
    /** Reihenfolge | erforderlich **/
    public ordernumber: number | null = null;
    /** Datensatz gültig j/n | max. 1 Zeichen | erforderlich **/
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Folgeimpfstoff>) {
        Object.assign(this, data);
    }
}
